import * as actionType from "../constants";
import * as commonData from "../Common";

export const fetchattributelistingforboard = (inputs) => async (dispatch) => {
  const api = commonData.commonData().apiUrl;
  dispatch({ type: actionType.BOARD_FALSE_DEFAULT });
  dispatch({ type: actionType.LOADING_FORM_ATTRIBUTE });
  try {
    const response = await fetch(`${api}tattle/attributes`, {
      method: "post",
      body: JSON.stringify(inputs),
    });

    const rdata = await response.json();
    if (rdata.code === 200) {
      dispatch({
        type: actionType.BOARD_ATTRIBUTE_LISTING,
        payload: {
          attribute: rdata.data,
          status: rdata.code,
        },
      });
    } else {
      dispatch({
        type: actionType.BOARD_ATTRIBUTE_LISTING,
        payload: {
          status: rdata.code,
        },
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const getTattleDetails = (inputs, any) => async (dispatch) => {
  const api = commonData.commonData().apiUrl;
  if (any !== "status") {
    dispatch({ type: actionType.CLEARING_ALL_COLUMNS });
    dispatch({ type: actionType.LOADING_FORM_ATTRIBUTE });
    dispatch({
      type: actionType.BOARD_ATTRIBUTE_TATTLE_DETAILS_NULL,
      payload: {
        rows: [],
      },
    });
  }
  try {
    const response = await fetch(`${api}tattle/row-details`, {
      method: "post",
      body: JSON.stringify(inputs),
    });

    const rdata = await response.json();
    if (rdata.code === 200) {
      dispatch({
        type: actionType.BOARD_ATTRIBUTE_TATTLE_DETAILS,
        payload: {
          bord_details: rdata.data.attributes || [],
          rows: rdata.data.rows,
          status: rdata.code,
          child_board: rdata.data?.child_board || [],
          users: rdata.data.users,
        },
      });
      dispatch(
        getChildBoards({
          app_token: inputs.app_token,
          attribute_set_key: inputs.attribute_set_key,
          customer_tattle_uuid: inputs.customer_tattle_uuid,
        })
      );
      return rdata;
    } else {
      dispatch({
        type: actionType.BOARD_ATTRIBUTE_LISTING,
        payload: {
          status: rdata.code,
        },
      });
      return rdata;
    }
  } catch (error) {
    console.log(error);
  }
};
const getChildBoards = (inputs) => async (dispatch) => {
  const api = commonData.commonData().apiUrl;
  try {
    const resp = await fetch(`${api}tattle/get-child-boards`, {
      method: "post",
      body: JSON.stringify(inputs),
    });
    const rdata = await resp.json();
    const { code, data } = rdata;
    if (code === 200) {
      dispatch({ type: actionType.GET_CHILD_BOARD, payload: data });
    }
  } catch (error) {
    console.log(error);
  }
};
